import { useMutation } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { getPredictedDefaultProcessStep } from "#modules/defaultProcessSteps/infra/getPredictedDefaultProcessStep.api";

export const useGetDefaultProcessStep = () => {
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: getPredictedDefaultProcessStep,
    onError: (err: Error) => {
      errorHandler(err);
    },
  });

  return { getDefaultProcessStep: mutateAsync, ...rest };
};
